export const CAREER_ANALYSE = `{
  id
  input
  verified
  status
  career_id
  partner_id
  time_needed
}`
